export default __webpack_public_path__ + "12f4d9c4a4e5296b76c3e36d4c61586b.png";